import { useState, useEffect } from 'react';
import { Row, Col, Descriptions, Typography } from 'antd';
import Data from '../../../CustomText/data';
import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons';
import API from '../../../../services/API';

const { Text } = Typography;

const DELINQUENT_DAYS_LIMIT = 29;

export default function StatementView({ statement, patchStatus, type = null, allowDownload = false }) {
  const columns = { xs: 2, sm: 1, md: 6};

  const [isDifferenceEnabled, setIsDifferenceEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (statement?.statementId && statement?.original?.statementId) {
      setIsDifferenceEnabled(true);
    } else {
      setIsDifferenceEnabled(false);
    }
  }, [statement?.statementId, statement?.original?.statementId]);

  const view = (key) => {
    if (!isDifferenceEnabled) {
      return statement?.[key];
    }

    if (`${statement?.original[key]}` === `${statement?.[key]}`) {
      return <Text>{statement?.[key]}</Text>;
    }

    return <>
      <Text strong type="danger" delete>{statement?.original[key]}</Text>
      &nbsp;&nbsp;&nbsp;
      <Text type={patchStatus?.status ? "success" : "secondary"}>{statement?.[key]}</Text>
    </>;
  }

  const viewDate = (key) => {
    if (!isDifferenceEnabled) {
      return statement?.[key]?.toString();
    }

    if (`${statement?.original[key] || ''}` === `${statement?.[key]?.format("YYYY-MM-DD") || ''}`) {
      return <Text type="secondary">{statement?.[key]?.format("YYYY-MM-DD")}</Text>;
    }

    return <>
      <Text type="danger" delete>{statement?.original[key]}</Text>
      &nbsp;&nbsp;&nbsp;
      <Text type={patchStatus?.status ? "success" : "secondary"}>{statement?.[key]?.format("YYYY-MM-DD")}</Text>
    </>;
  }

  const viewDaysDelinquent = () => {
    const daysDelinquent = statement?.daysDelinquent;
    // A patched value already shows as old and new, so its colors keep that meaning
    const isPatched = isDifferenceEnabled && `${statement?.original?.daysDelinquent}` !== `${daysDelinquent}`;

    if (!isPatched && Number(daysDelinquent) > DELINQUENT_DAYS_LIMIT) {
      return <Text style={{ color: '#f5222d' }}>{daysDelinquent}</Text>;
    }

    return view("daysDelinquent");
  }

  const downloadStatement = async () => {
    setLoading(true);
    try {
      const statementBlob = await API.getStatementFile({ type, statementId: statement?.entryId });
      var file = new Blob([statementBlob], {type: 'application/pdf'});
      const url = window.URL.createObjectURL(file);
      window.open(url)
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }
const awwal = false;
  return (
    awwal ? 
    (<Descriptions layout="vertical" column={columns} size="small">
      <Descriptions.Item label="Statement Id" span={2}>
        { statement?.statementId }
      </Descriptions.Item>
      <Descriptions.Item label="Statement Date">
        { statement?.statementDate }
      </Descriptions.Item>
      <Descriptions.Item label="Payment Due Date">
        { statement?.paymentDueDate }
      </Descriptions.Item>
      <Descriptions.Item label="Date of 1st Delinquency" span={2}>
        { statement?.dateOfFirstDelinquency }
      </Descriptions.Item>

      <Descriptions.Item label="Last Payment Date">
        { viewDate("lastPaymentDate") }
      </Descriptions.Item>
      <Descriptions.Item label="Scheduled Monthly Payment">
        { view("scheduledMonthlyPayment") }
      </Descriptions.Item>
      <Descriptions.Item label="Actual Monthly Payment">
        { view("actualMonthlyPayment") }
      </Descriptions.Item>
      <Descriptions.Item label="Current Balance">
        { view("currentBalance") }
      </Descriptions.Item>
      <Descriptions.Item label="Amount Past Due">
        { view("amountPastDue") }
      </Descriptions.Item>
      <Descriptions.Item label="Days Delinquent">
        { view("daysDelinquent") }
      </Descriptions.Item>
    </Descriptions> )

    : (
      <>
        <Row justify={'center'}>
          <Col span="8">
            <Data title="Statement Id" value={statement?.statementId} copyable />
          </Col>
          <Col span="4">
            <Data title="Statement Date" value={statement?.statementDate} />
          </Col>
          <Col span="4">
            <Data title="Payment Due Date" value={statement?.paymentDueDate} />
          </Col>
          <Col span="7">
            <Data title="Date of 1st Delinquency" value={statement?.dateOfFirstDelinquency} />
          </Col>
          <Col span="1">
            { allowDownload && !loading && <DownloadOutlined onClick={downloadStatement} /> }
            { loading && <LoadingOutlined /> }
          </Col>
        </Row>
        &nbsp;
        <Row justify={'center'}>
          <Col span="4">
            <Data title="Last Payment Date" value={viewDate("lastPaymentDate")} />
          </Col>
          <Col span="4">
            <Data title="Scheduled Monthly Payment" value={view("scheduledMonthlyPayment")} />
          </Col>
          <Col span="4">
            <Data title="Actual Monthly Payment" value={view("actualMonthlyPayment")} />
          </Col>
          <Col span="4">
            <Data title="Current Balance" value={view("currentBalance")} />
          </Col>
          <Col span="4">
            <Data title="Amount Past Due" value={view("amountPastDue")} />
          </Col>
          <Col span="4">
            <Data title="Days Delinquent" value={viewDaysDelinquent()} />
          </Col>
        </Row>
      </>
    )
  );
}